/* stylelint-disable */
import styled from 'styled-components';

export const ListingLandingPage = styled.div`
  margin-top: -1px;
  clear: both;
`;

export const CrossPromoPadding = styled.div`
  padding-bottom: 20px;
`;

export const HeroSubtextMaxWidth = styled.div`
  margin: 0 auto;
  max-width: 620px;
`;

export const PromoLogos = styled.div`
  padding-top: 25px;
  text-align: center;

  @media (min-width: 1280px) {
    text-align: left;
  }

  img {
    display: block;
    margin: 0 auto;
    padding-top: 16px;

    &:first-child {
      padding-top: 0;
    }

    @media (min-width: 576px) {
      display: inline-block;
      margin-right: 26px;
      padding-top: 0;
    }
  }
`;

export const Sup = styled.sup`
  vertical-align: super;
`;
